module.exports = __webpack_public_path__ + "static/media/Banner4.b284ebf6.jpg";